import { LOGIC_BLOCKS as logic } from '../base';

export const LOGIC_BLOCKS = logic;
